var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilters = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.7647C11.9998 13.5094 11.9022 13.2637 11.7269 13.0781L1.9127 2.68662C1.3104 2.04889 1.76251 1 2.63972 1H27.36C28.2372 1 28.6893 2.04889 28.087 2.68662L18.2728 13.0781C18.0975 13.2637 17.9998 13.5094 17.9998 13.7647V25.7639C17.9998 26.1427 17.7858 26.489 17.4471 26.6584L13.4471 28.6584C12.7822 28.9908 11.9998 28.5073 11.9998 27.7639V13.7647Z",
    stroke: "#DADDDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilters);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filters.cd3b30ba1a4710f08f6301b9e27ee23f.svg";